

import React, { useEffect, useState, useContext } from "react";
import schoolApi from "../../api/schoolApi";

import { Col, Row, Table } from "react-bootstrap";
import {
  DatatableWrapper,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
//import { ShimmerTable } from "react-shimmer-effects";
import { Link } from "react-router-dom";
//import { toast } from "react-toastify";
import moment from "moment";
import { SessionContext } from "../SessionProvider";


const FeeDuesShow = () => {
  const { selectedSessionId } = useContext(SessionContext);

 // const [sessionOptions, setSessionOptions] = useState([]);
 // const [currentSessionYear, setCurrentSessionYear] = useState();
  const [reportData, setReportData] = useState({ classid: "", session_id: selectedSessionId ? selectedSessionId : "" });
  const [feeDueData, setFeeDueData] = useState([]);
  const [settings, setSettings] = useState({});
  // const [netAmount, setNetAmount] = useState({
  //   total_amount: 0,
  //   total_due_fees: 0,
  //   total_others_amount: 0,
  // });
 // const navigate = useNavigate();


  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const ResultSettings = await schoolApi.getAllSetting();
        if (ResultSettings.success) {
          setSettings({
            frequency: ResultSettings?.data?.filter(
              (res) => res.key === "frequency"
            )[0].value,
            late_fee: ResultSettings?.data?.filter(
              (res) => res.key === "late_fee"
            )[0].value,
          });
        }

        // const sessions = await schoolApi.fetchSessions();
        // if (sessions.success) {
        //   const currentDate = new Date();
        //   const fetchSelectedSessionResult = sessions?.result?.find((res) => {
        //     const startDate = new Date(res.startdate);
        //     const endDate = new Date(res.enddate);
        //     return currentDate >= startDate && currentDate <= endDate;
        //   });



          // if (fetchSelectedSessionResult) {
          //   setReportData((prevData) => ({
          //     ...prevData,
          //     session_id: fetchSelectedSessionResult.id,
          //   }));

            // const options = sessions?.result?.map((sess) => ({
            //   value: sess.id,
            //   label: sess.year,
            // }));
           // setSessionOptions(options);
        //  }
      //  }
      } catch (error) {}
    };

    fetchSessions();


  }, []);

  useEffect(() => {
    const fetchFeeData = async () => {
      try {
        const result = await schoolApi.fetchDueFees(
          reportData.classid,
          selectedSessionId
        );
        if (result.success) {
          filterData(result.result);
        }
      } catch (error) {
        setFeeDueData([]);
      }
    };

    if (selectedSessionId && settings.frequency && settings.late_fee) {
      fetchFeeData();
    }
  }, [reportData, selectedSessionId, settings]);
  const formatNumberWithCommas = (number) => {
    return number ? number.toLocaleString("en-IN") : "0";
  };

  const labels = {
    beforeSelect: "Rows: ",
  };

  const filterData = (result) => {
    let data = [];

    result?.forEach((item) => {
      const currentDate = moment();

      item?.installments?.forEach((inst) => {
        if (
          inst.status === "pending" &&
          moment(inst.due_date).isSameOrBefore(currentDate)
        ) {
          const daysOverdue = currentDate.diff(moment(inst.due_date), "days");
          const lateFee =
            Math.round(
              (daysOverdue + parseInt(settings.frequency)) /
                parseInt(settings.frequency)
            ) * parseInt(settings.late_fee);

          const dueAmount = Number(inst.installmentamount || 0);
          const totalAmount = dueAmount + lateFee;

          data.push({
            studentname: item.student_name,
            class: item.classname,
            section_name: item.section_name,
            month: inst.month,
            due_amount: dueAmount,
            others: lateFee,
            total_amount: totalAmount,
            due_date: inst.due_date,
            status: "Overdue",
            session_id: item.sessionid,
            student_addmission_id: item.student_addmission_id,
            student_id: item.student_id,
            email: item.email,
            dateofbirth: item.dateofbirth,
            total_fees: item.total_fees,
            phone: item.phone,
            category: item.category,
          });
        }
      });
    });

    setFeeDueData(data);
    // setNetAmount({
    //   total_amount: formatNumberWithCommas(total_amount),
    //   total_due_fees: formatNumberWithCommas(total_due_fees),
    //   total_others_amount: formatNumberWithCommas(total_others_amount),
    // });
  };

  const header = [
    {
      title: "Name",
      prop: "studentname",
      isFilterable: true,
      show: true,
      cell: (row) => (
        <Link to={"/feedepositeedit/e"} state={{ row }}>
          {row.studentname}
        </Link>
      ),
    },
    {
      title: "Class",
      prop: "class",
      isFilterable: true,
      show: true,
      cell: (row) => (
        <>
          {row.class} {row.section_name && ` (${row.section_name})`}
        </>
      ),
    },
    { title: "Month", prop: "month", isFilterable: true, show: true },
    {
      title: "Due Fees",
      prop: "due_amount",
      isFilterable: true,
      show: true,
      cell: (row) => <>{formatNumberWithCommas(row.due_amount)}</>,
    },
    {
      title: "Late Fee",
      prop: "others",
      isFilterable: true,
      show: true,
      cell: (row) => <>{formatNumberWithCommas(row.others)}</>,
    },
    {
      title: "Total",
      prop: "total_amount",
      isFilterable: true,
      show: true,
      cell: (row) => <>{formatNumberWithCommas(row.total_amount)}</>,
    },
    {
      title: "Due Date",
      prop: "due_date",
      isFilterable: true,
      show: true,
      cell: (row) => <>{moment(row.due_date).format("DD-MM-YYYY")}</>,
    },
    { title: "Status", prop: "status", isFilterable: true, show: true },
  ];

  const totals = feeDueData.reduce(
    (acc, item) => {
      acc.due_amount += Number(item.due_amount || 0);
      acc.others += Number(item.others || 0);
      acc.total_amount += Number(item.total_amount || 0);
      return acc;
    },
    { due_amount: 0, others: 0, total_amount: 0 }
  );

  return (
    <div>
      <Row className="g-0">
        <Col lg={12} className="">
          <DatatableWrapper
            body={feeDueData}
            headers={header}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 10,
                options: [10, 20, 30, 50],
              },
            }}
          >
            <Row className="mb-3 align-items-center">
              <Col xs={12} md={6} className="d-flex align-items-center gap-3">
                <PaginationOptions labels={labels} />
                <div className="small text-muted">
                  Total Records: {feeDueData.length}
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                className="d-flex justify-content-md-end mt-2 mt-md-0"
              >
                {feeDueData.length > 0 && (
                  <Link to="/duefeereport" state={reportData}>
                    View more records
                  </Link>
                )}
              </Col>
            </Row>
            <Table striped className="data-table">
              <TableHeader />
              <TableBody />
            </Table>
            <Row className="mt-3 align-items-center">
              <Col xs={12} md={7}>
                <div className="small fw-semibold">
                  Total Due Fees: {formatNumberWithCommas(totals.due_amount)}{" "}
                  | Late Fee: {formatNumberWithCommas(totals.others)} | Grand
                  Total: {formatNumberWithCommas(totals.total_amount)}
                </div>
              </Col>
              <Col
                xs={12}
                md={5}
                className="d-flex justify-content-md-end mt-2 mt-md-0"
              >
                <Pagination />
              </Col>
            </Row>
          </DatatableWrapper>
        </Col>
        <Col lg={2}></Col>
      </Row>
    </div>
  );
};

export default FeeDuesShow;
